import { ICompany, ICompanyCountry } from '../../interfaces/Company';

const MEXICO_COUNTRY_CODE = 'MX';
const COUNTRY_ALIASES: Record<string, string> = {
  MEX: 'MX',
  MEXICO: 'MX',
  PER: 'PE',
  PERU: 'PE',
};
const OBJECT_ID_REGEX = /^[a-f\d]{24}$/i;

function normalizeCountryCandidate(value?: string | null): string | null {
  if (!value) return null;

  const normalized = value.trim().toUpperCase();
  if (!normalized || OBJECT_ID_REGEX.test(normalized)) {
    return null;
  }

  if (COUNTRY_ALIASES[normalized]) {
    return COUNTRY_ALIASES[normalized];
  }

  return normalized;
}

function getCountryCode(country?: string | ICompanyCountry | null): string | null {
  if (!country) return null;

  if (typeof country === 'string') {
    const normalized = normalizeCountryCandidate(country);
    return normalized && normalized.length === 2 ? normalized : null;
  }

  const codeCandidate = normalizeCountryCandidate(country.iso || country.iso3 || country.name || country.nicename || null);
  if (!codeCandidate) return null;

  return codeCandidate.length === 2 ? codeCandidate : null;
}

function getResolvedFiscalCountryCode(company?: ICompany | null): string | null {
  const fiscalCountryCode = getCountryCode(company?.fiscalSettings?.fiscalCountry);
  const operationalCountryCode = getCountryCode(company?.country);

  return fiscalCountryCode ?? operationalCountryCode;
}

export function getSubscriptionBillingCountryCode(company?: ICompany | null): string | null {
  return getResolvedFiscalCountryCode(company);
}

export function isSubscriptionFiscalCountryMexico(company?: ICompany | null): boolean {
  return getResolvedFiscalCountryCode(company) === MEXICO_COUNTRY_CODE;
}

export function getOperationalCountryCode(company?: ICompany | null): string | null {
  return getCountryCode(company?.country);
}

export function isOperationalCountryMexico(company?: ICompany | null): boolean {
  return getOperationalCountryCode(company) === MEXICO_COUNTRY_CODE;
}
